// @flow
import type {FacetOption, FacetList, AppliedFacets} from "./types";

const alreadyOrderedFacet = (orderedFacets: FacetList) =>
  ({facetName, id}: FacetOption): boolean => (
    !orderedFacets.some(orderedFacet => orderedFacet.id === id
      || (orderedFacet.facetName === 'price' && facetName === 'price'))
  )

const noLongerAppliedFacet = (appliedFacets: AppliedFacets) =>
  ({facetName, id}: FacetOption): boolean =>
    !!appliedFacets[facetName].some(facet => facet.id === id || facetName === 'price' && !!facet);


const getUpdatedOrderedFacetList = (appliedFacets: AppliedFacets, orderedFacets: FacetList): FacetList =>{
  const newFacetSelections = Object.values(appliedFacets)
    // $FlowFixMe [our version of flow does not support flat func for Arrays]
    .flat()
    .filter(alreadyOrderedFacet(orderedFacets));
  const newOrderedFacets = orderedFacets
    .filter(noLongerAppliedFacet(appliedFacets));
  return [...newOrderedFacets, ...newFacetSelections];
};

export default getUpdatedOrderedFacetList;
